import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        view: '=',
        classifiers: '=',
        sites: '<'
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'course.Manage courses' | translate }}</h1>
            <a class="btn add" ng-if="vm.canManageCourses" ui-sref="authorized.courses.courses.add.general()">{{ 'course.Add course' | translate }}</a>
        </div>
        <div class="heading01">
            <ul class="actions01">
            <li><a class="btn filter" ng-click="vm.toggleFilter()">{{ 'filter.Filter courses' | translate }}</a></li>
            <li>
                <a class="btn grid" ng-if="vm.view=='list'" ng-click="vm.view='grid'">{{ 'filter.View as grid' | translate }}</a>
                <a class="btn list" ng-if="vm.view=='grid'" ng-click="vm.view='list'">{{ 'filter.View as list' | translate }}</a>
            </li>
        </ul>
        </div>
        <courses-filter-courses
            classifiers="vm.classifiers"
            view="vm.view"
            list="vm.list"
            default-filter="vm.defaultFilter"
            filter="vm.filter"
            component="'course'"
            show-filter="vm.showFilter"
            course-access-sites="vm.sites"
        />
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <div class="well" ng-click="vm.closeAllMenus()" ng-if="vm.list.items.length">
            <pagination-tools list="vm.list"></pagination-tools>
            <courses-courses-list-list ng-if="vm.view === 'list'" list="vm.list" />
            <pagination ng-if="vm.view === 'list'" list="vm.list"></pagination>
        </div>
        <courses-courses-list-grid ng-if="vm.view === 'grid'" list="vm.list" />
    `
})
export default class {
    constructor (COURSE_STATUS_ENUM, ListFactory, CourseResource, PrivilegeService) {
        this.COURSE_STATUS_ENUM = COURSE_STATUS_ENUM;
        this.ListFactory = ListFactory;
        this.CourseResource = CourseResource;
        this.PrivilegeService = PrivilegeService;
    }

    $onInit () {
        this.canManageCourses = this.PrivilegeService.canManageCourses();
        this.defaultFilter = { status: this.COURSE_STATUS_ENUM.KEYS.COMPLETE };
        this.filter = {};
        this.list = this.ListFactory.createWithPagination(this.CourseResource.getCourses.bind(this.CourseResource));
        // we set perPage via pagination to avoid resetting it when using filter
        this.list.pagination.perPage = 50;
        this.list.fetch({ expand: 'activeI18n,sites' }, this.defaultFilter);
    }

    toggleFilter () {
        this.showFilter = !this.showFilter;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/list/index.js